import React, { useState } from "react"
import Slider from "react-slick"
import { SampleNextArrow, SamplePrevArrow } from "./SliderArrow"
import { SingleService } from "components/service-comparison/SingleService"
import { TextAndImageContentBlock } from "components/content-blocks/TextAndImageContentBlock"
import type { TabElements } from "./tabbed-content-block-types"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./tabbed-content-slider.module.scss"

interface TabbedContentSliderProps {
  content: TabElements[]
  hasAltBackgroundColor: boolean
}

export const TabbedContentSlider = ({
  content,
  hasAltBackgroundColor,
}: TabbedContentSliderProps) => {
  const [nav1, setNav1] = useState<Slider>()
  const [nav2, setNav2] = useState<Slider>()

  const tabOverlayVariation = hasAltBackgroundColor ? "-altBg" : ""

  const tabSliderClassName =
    content?.length <= 3
      ? `fr-tabbed-content-slider__tabs fr-tabbed-content-slider__tabs--justifyContentCenter`
      : "fr-tabbed-content-slider__tabs"

  const tabSettings = {
    arrows: false,
    centerMode: true,
    className: tabSliderClassName,
    dots: false,
    infinite: true,
    initialSlide: 0,
    slidesToScroll: 1,
    slidesToShow: 3,
    swipeToSlide: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  const contentSettings = {
    className: "fr-tabbed-content-slider__content",
    dots: true,
    dotsClass: "slick-dots fr-tabbed-content-slider__slick-dots",
    focusOnSelect: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    swipeToSlide: true,
  }

  return (
    <>
      <div className="fr-tabbed-content-slider__tabs-wrapper">
        <span
          className={`fr-tabbed-content-slider__tabs-gradient-overlay fr-tabbed-content-slider__tabs-gradient-overlay--left${tabOverlayVariation}`}
        />
        <Slider
          asNavFor={nav2}
          {...tabSettings}
          ref={slider1 => slider1 && setNav1(slider1)}
        >
          {content?.map(tabContent => {
            if (!tabContent) return
            const { id, svg_icon, tab_title } = tabContent

            return (
              <div key={id} style={{ width: 248 }}>
                <div className="fr-tabbed-content-slider__single-tab">
                  {svg_icon && (
                    <span
                      contentEditable="false"
                      dangerouslySetInnerHTML={{ __html: svg_icon }}
                    />
                  )}
                  <strong>{tab_title}</strong>
                </div>
              </div>
            )
          })}
        </Slider>
        <span
          className={`fr-tabbed-content-slider__tabs-gradient-overlay fr-tabbed-content-slider__tabs-gradient-overlay--right${tabOverlayVariation}`}
        />
      </div>

      <Slider
        asNavFor={nav1}
        {...contentSettings}
        ref={slider2 => slider2 && setNav2(slider2)}
      >
        {content?.map(tabContent => {
          const tabItemsContentBlock = tabContent?.content_block
          const tabItemsService = tabContent?.service

          if (
            tabContent.hasOwnProperty("service") &&
            tabItemsService !== null
          ) {
            const { flag, icon, name, ...tabItemsServicesWithOmittedProps } =
              tabItemsService

            return <SingleService {...tabItemsServicesWithOmittedProps} />
          }

          if (!tabItemsContentBlock) return null

          const {
            // alternate_background_color,
            // content_block_type,
            // eyebrow_text,
            // sub_heading,
            // svg_icon,
            buttons,
            heading,
            id,
            image,
            text,
          } = tabItemsContentBlock

          return (
            <TextAndImageContentBlock
              buttons={buttons}
              content_block_type="default"
              eyebrow_text={null}
              hasBlockPadding={false}
              hasContainerClassName={false}
              heading={heading}
              image={image}
              key={id}
              text={text?.data.text ?? null}
            />
          )
        })}
      </Slider>
    </>
  )
}
